// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1qEqg","title":"Info_title__2XJ7l","links":"Info_links__1rYRN","link":"Info_link__2xkqK","logo":"Info_logo__3PJkE"};